import {
    ADD_HOME_DECO_PRODUCT_DATA_REQUEST,
    ADD_HOME_DECO_PRODUCT_DATA_SUCCESS,
    ADD_HOME_DECO_PRODUCT_DATA_FAILED,
    HOME_DECO_CLEAR_ADD_PRODUCT
} from '../../actions/product/add-home-deco-product-data'

const initialState = {
    product: null,
    error: null,
    requesting: false,
    completed: false,
}

export const homeDecoNewProduct = (state = initialState, action) => {
    switch (action.type) {
        case ADD_HOME_DECO_PRODUCT_DATA_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                error: null,
            })
        case ADD_HOME_DECO_PRODUCT_DATA_SUCCESS:
            return Object.assign({}, state, {
                product: action.payload.data.payload,
                requesting: false,
                error: null,
                completed: true
            })
        case ADD_HOME_DECO_PRODUCT_DATA_FAILED:
            return Object.assign({}, state, {
                requesting: false,
                error: action.error
            })
        case HOME_DECO_CLEAR_ADD_PRODUCT:
            return initialState
        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/product/home-deco-new-product.js